/*!
 * @license
 * Copyright © 2005-2024 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { BaseApi } from './base.api';
import { buildCollectionParam } from '../../../alfrescoApiClient';
import { throwIfNotDefined } from '../../../assert';
export class GsSitesApi extends BaseApi {
    createRMSite(siteBodyCreate, opts) {
        throwIfNotDefined(siteBodyCreate, 'siteBodyCreate');
        return this.post({
            path: '/gs-sites',
            queryParams: opts,
            bodyParam: siteBodyCreate
        });
    }
    deleteRMSite() {
        return this.delete({
            path: '/gs-sites/rm'
        });
    }
    getRMSite(opts) {
        const queryParams = {
            fields: buildCollectionParam(opts === null || opts === void 0 ? void 0 : opts.fields, 'csv')
        };
        return this.get({
            path: '/gs-sites/rm',
            queryParams
        });
    }
    updateRMSite(siteBodyUpdate, opts) {
        throwIfNotDefined(siteBodyUpdate, 'siteBodyUpdate');
        const queryParams = {
            fields: buildCollectionParam(opts === null || opts === void 0 ? void 0 : opts.fields, 'csv')
        };
        return this.put({
            path: '/gs-sites/rm',
            queryParams,
            bodyParam: siteBodyUpdate
        });
    }
}
